<template>
  <div id = "hoverbar" class="notification" :class="{ fixed: hoverBarData.fixed }">
    <button class="delete" @click="hideBar"></button>
    <h1 class = "hoverbar-title"> {{$t('hoverBar.title')}}</h1>
    <ChartPieCountdown :ext_date='endDate'></ChartPieCountdown>
  </div>  
</template>

<script>
import ChartPieCountdown from '@/components/widgets/ChartPieCountdown'
export default {
  props: [
    'hoverBarData'
  ],
  components:{ 
    ChartPieCountdown
  },
  data() {
    return {
      endDate: '4 Mar 2019 00:00:00 GMT+0200'
    }
  },
  methods: {
    hideBar() {
      this.$emit('hideBar');
    }
  }
}
</script>

<style lang="scss" scoped>
#hoverbar {
  margin-bottom: 0;
  height: 16vh;
  width: 100%;
  background-color: darken($secondary-color, 10%);
  opacity: 0.8;
  z-index: 600;
  position: relative;
}

.fixed {
  position: fixed !important;
  bottom: 0px; 
}

.hoverbar-text {
  color: #fff;
}

.hoverbar-title {
  font-size: 20px;
  margin-bottom: 10px;
  color: #fff;
}

@media screen and (max-height: 800px) {
    #hoverbar {
      height: 25vh;
    }
}
</style>
